export default [
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'LISTOFSTRINGS',
    name: 'orderedReferenceList',
    defaultName: 'Ordered Reference List',
  },
  {
    type: 'STRING',
    name: 'curatedMediaLists',
    defaultName: 'Curated Media Lists',
  },
  {
    type: 'STRING',
    name: 'curatedSeriesLists',
    defaultName: 'Curated Series Lists',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'lastUpdatedBy',
    defaultName: 'Last Updated By',
  },
  {
    type: 'STRING',
    name: 'highlightSeriesId',
    defaultName: 'Highlight Series Id',
  },
  {
    type: 'STRING',
    name: 'processedSeries',
    defaultName: 'Processed Series',
  },
  {
    type: 'STRING',
    name: 'processedMedia',
    defaultName: 'Processed Media',
  },
]
